module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"_0_11_0_logoIcon__logo___3cOup","logoEn":"_0_11_0_logoIcon__logoEn___1BZmw","dots-light":"_0_11_0_logoIcon__dots-light___38cae","monochrome":"_0_11_0_logoIcon__monochrome___2Z0oI","dots-dark":"_0_11_0_logoIcon__dots-dark___2hB6z","name-light":"_0_11_0_logoIcon__name-light___ILq_x","name-dark":"_0_11_0_logoIcon__name-dark___1T3Yy"};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Chevron", function() { return /* reexport */ Chevron; });
__webpack_require__.d(__webpack_exports__, "Arrow", function() { return /* reexport */ Arrow; });
__webpack_require__.d(__webpack_exports__, "Move", function() { return /* reexport */ Move; });
__webpack_require__.d(__webpack_exports__, "CartAdd", function() { return /* reexport */ CartAdd; });
__webpack_require__.d(__webpack_exports__, "CartAdded", function() { return /* reexport */ CartAdded; });
__webpack_require__.d(__webpack_exports__, "ExternalIcon", function() { return /* reexport */ ExternalIcon; });
__webpack_require__.d(__webpack_exports__, "Minus", function() { return /* reexport */ Minus; });
__webpack_require__.d(__webpack_exports__, "Plus", function() { return /* reexport */ Plus; });
__webpack_require__.d(__webpack_exports__, "CoinIcon", function() { return /* reexport */ CoinIcon; });
__webpack_require__.d(__webpack_exports__, "LogoIcon", function() { return /* reexport */ LogoIcon; });
__webpack_require__.d(__webpack_exports__, "Search", function() { return /* reexport */ Search; });
__webpack_require__.d(__webpack_exports__, "AccountIcon", function() { return /* reexport */ AccountIcon; });
__webpack_require__.d(__webpack_exports__, "BurgerIcon", function() { return /* reexport */ BurgerIcon; });
__webpack_require__.d(__webpack_exports__, "CartEmptyIcon", function() { return /* reexport */ CartEmptyIcon; });
__webpack_require__.d(__webpack_exports__, "CartFilledIcon", function() { return /* reexport */ CartFilledIcon; });
__webpack_require__.d(__webpack_exports__, "DotsIcon", function() { return /* reexport */ DotsIcon; });
__webpack_require__.d(__webpack_exports__, "Check", function() { return /* reexport */ Check; });
__webpack_require__.d(__webpack_exports__, "Close", function() { return /* reexport */ Close; });
__webpack_require__.d(__webpack_exports__, "LangIcon", function() { return /* reexport */ LangIcon; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(0);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// CONCATENATED MODULE: ./src/Icons/Chevron.tsx

/** Иконка-крышечка */
function Chevron(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 8" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M7.008 6.337 1.355.647l-.71.705 6.363 6.404 6.347-6.388-.71-.704-5.637 5.673Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/Arrow.tsx

/** Иконка-стрелка */
function Arrow(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 14" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M13.787 7.492H0v-1h13.787l-5.17-5.137.705-.71 6.387 6.347-6.403 6.363-.705-.71 5.186-5.153Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/Move.tsx

/** Иконка перемещения (например, для слайдеров) */
function Move(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: className, viewBox: "0 0 12 19" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "m.978 17.493 1.06 1.06 9.016-9.015L2.038.522.978 1.583l7.936 7.955-7.936 7.955Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/CartAdd.tsx

/** Иконка "Добавить в корзину" */
function CartAdd(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: className, viewBox: "0 0 20 20" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M14.5 6V5a4.5 4.5 0 1 0-9 0v1h-.794a2.5 2.5 0 0 0-2.469 2.105l-1.706 9A2.5 2.5 0 0 0 3 20h5.655v-1H3a1.5 1.5 0 0 1-1.481-1.737l1.706-9A1.5 1.5 0 0 1 4.705 7h10.656a1.5 1.5 0 0 1 1.47 1.206l.16.794h1.02l-.199-.99A2.5 2.5 0 0 0 15.361 6h-.86ZM10 1.5A3.5 3.5 0 0 0 6.5 5v1h7V5A3.5 3.5 0 0 0 10 1.5Z", clipRule: "evenodd" }),
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M15 15v-4h1v4h4v1h-4v4h-1v-4h-4v-1h4Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/CartAdded.tsx

/** Иконка "Добавлено в корзину" */
function CartAdded(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: className, viewBox: "0 0 20 20" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M14.5 6V5a4.5 4.5 0 1 0-9 0v1h-.794a2.5 2.5 0 0 0-2.469 2.105l-1.706 9A2.5 2.5 0 0 0 3 20h5.655v-1H3a1.5 1.5 0 0 1-1.481-1.737l1.706-9A1.5 1.5 0 0 1 4.705 7h10.656a1.5 1.5 0 0 1 1.47 1.206l.16.794h1.02l-.199-.99A2.5 2.5 0 0 0 15.361 6h-.86ZM10 1.5A3.5 3.5 0 0 0 6.5 5v1h7V5A3.5 3.5 0 0 0 10 1.5Z", clipRule: "evenodd" }),
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M20 12.653 13.335 20 10 16.635l.742-.686 2.56 2.583L19.227 12l.773.653Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/ExternalIcon.tsx

/** Иконка "Ссылка" */
function ExternalIcon(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: className, viewBox: "0 0 12 12" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M6.7.4h4.911v4.892h-.7V1.595L5.552 6.954l-.495-.495 5.36-5.36H6.7V.4ZM.4 1.8h3.5v.7H1.1v8.398h8.4V7.4h.7v4.198H.4V1.8Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/Minus.tsx

/** Иконка "Минус" */
function Minus(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 2" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M10.25.25H21.5v1.5H.5V.25h9.75Z", clipRule: "evenodd" })));
}

// EXTERNAL MODULE: external "tslib"
var external_tslib_ = __webpack_require__(3);

// CONCATENATED MODULE: ./src/Icons/Plus.tsx


/** Иконка "Плюс" */
function Plus(props) {
    return (external_react_default.a.createElement("svg", Object(external_tslib_["__assign"])({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22" }),
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M10.25 10.25V.5h1.5v9.75h9.75v1.5h-9.75v9.75h-1.5v-9.75H.5v-1.5h9.75Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/Coin.tsx

var CoinIcon = function (_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 13" },
        external_react_default.a.createElement("circle", { cx: "6", cy: "7", r: "5", strokeWidth: "2" })));
};

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/Icons/types.ts
var ETheme;
(function (ETheme) {
    ETheme["light"] = "light";
    ETheme["dark"] = "dark";
})(ETheme || (ETheme = {}));
var ELang;
(function (ELang) {
    ELang["ru"] = "ru";
    ELang["en"] = "en";
})(ELang || (ELang = {}));

// EXTERNAL MODULE: ./src/Icons/Logo/logoIcon.scss
var logoIcon = __webpack_require__(1);
var logoIcon_default = /*#__PURE__*/__webpack_require__.n(logoIcon);

// CONCATENATED MODULE: ./src/Icons/Logo/index.tsx




/** Состоит из точек и текста:
 * текст всегда белый при тёмной теме и чёрный при светлой теме;
 * точки серые если !monochrome, иначе их цвет идентичен тексту */
var LogoIcon = function (_a) {
    var _b, _c;
    var className = _a.className, _d = _a.monochrome, monochrome = _d === void 0 ? false : _d, _e = _a.theme, theme = _e === void 0 ? ETheme.light : _e, _f = _a.lang, lang = _f === void 0 ? ELang.ru : _f;
    return (external_react_default.a.createElement("div", { className: external_classnames_default()(logoIcon_default.a["" + (lang === ELang.ru ? 'logo' : 'logoEn')], className) }, lang === ELang.ru ? (external_react_default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 200 43" },
        external_react_default.a.createElement("path", { className: logoIcon_default.a["name-" + theme], fillRule: "evenodd", d: "M64.252 4.618c3.805 0 6.413 2.42 6.413 6.156 0 3.737-2.608 6.132-6.413 6.132H55.79v4.479h-4.308V4.618h12.77Zm-1.197 8.67c1.292 0 3.303 0 3.303-2.514 0-2.539-2.01-2.539-3.303-2.539H55.79v5.054h7.266Z", clipRule: "evenodd" }),
        external_react_default.a.createElement("path", { className: logoIcon_default.a["name-" + theme], d: "M112.197 4.618h-4.307V17.96l-10.836.004V4.618h-4.308v16.975c1.988-.005 9.701-.002 14.714 0h3.965v3.27h3.959l-.001-6.91h-3.186V4.618ZM121.568 8.043h13.663V4.618H117.26v16.767h17.971V17.96h-13.663v-3.402h13.663v-3.113h-13.663V8.043ZM153.178 4.618h4.308v16.767h-4.308v-6.563h-11.431v6.563h-4.308V4.618h4.308v6.563h11.431V4.618ZM179.086 8.235V4.618H159.29v3.617h7.745v13.15h4.307V8.235h7.744Z" }),
        external_react_default.a.createElement("path", { className: logoIcon_default.a["name-" + theme], fillRule: "evenodd", d: "M200 10.774c0-3.737-2.609-6.156-6.413-6.156h-12.77v16.767h4.307v-4.48h8.463c3.804 0 6.413-2.395 6.413-6.131Zm-4.308 0c0 2.515-2.01 2.515-3.302 2.515h-7.266V8.235h7.266c1.292 0 3.302 0 3.302 2.539Z", clipRule: "evenodd" }),
        external_react_default.a.createElement("path", { className: logoIcon_default.a["name-" + theme], d: "M79.814 21.4 91.456 4.618h-5.193l-5.799 8.351-5.798-8.35h-5.193l8.392 12.095L74.61 21.4h5.203ZM86.313 21.4v-.007l.005.007h-.005Z" }),
        external_react_default.a.createElement("path", { className: external_classnames_default()(logoIcon_default.a["dots-" + theme], (_b = {}, _b[logoIcon_default.a.monochrome] = monochrome, _b)), d: "M18.675 13.16c0 5.148-4.18 9.32-9.338 9.32C4.182 22.48 0 18.309 0 13.16c0-5.148 4.18-9.32 9.338-9.32 5.157 0 9.337 4.172 9.337 9.32ZM29.752 22.481c-5.157 0-9.338-4.173-9.338-9.32 0-5.149 4.18-9.322 9.338-9.322 5.156 0 9.337 4.173 9.337 9.321s-4.18 9.321-9.337 9.321ZM9.337 42.854c5.157 0 9.338-4.173 9.338-9.321s-4.18-9.321-9.338-9.321C4.181 24.212 0 28.385 0 33.532c0 5.149 4.18 9.322 9.337 9.322Z" }))) : (external_react_default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 223 43" },
        external_react_default.a.createElement("path", { className: external_classnames_default()(logoIcon_default.a["dots-" + theme], (_c = {}, _c[logoIcon_default.a.monochrome] = monochrome, _c)), fillRule: "evenodd", d: "M29.798 22.633a9.367 9.367 0 0 1-6.612-2.729 9.3 9.3 0 0 1-2.738-6.588 9.3 9.3 0 0 1 2.738-6.587 9.38 9.38 0 0 1 13.226-.001 9.313 9.313 0 0 1 2.74 6.588 9.288 9.288 0 0 1-2.74 6.59 9.353 9.353 0 0 1-6.614 2.727Zm-11.091-9.317a9.288 9.288 0 0 1-2.74 6.59 9.355 9.355 0 0 1-6.614 2.727 9.367 9.367 0 0 1-6.612-2.729 9.3 9.3 0 0 1-2.739-6.588 9.3 9.3 0 0 1 2.74-6.587 9.38 9.38 0 0 1 13.226-.001 9.315 9.315 0 0 1 2.739 6.588ZM9.353 43c2.48 0 4.859-.981 6.613-2.728a9.303 9.303 0 0 0 2.74-6.588 9.303 9.303 0 0 0-2.739-6.59 9.371 9.371 0 0 0-13.226 0 9.303 9.303 0 0 0-2.739 6.59 9.303 9.303 0 0 0 2.74 6.586A9.371 9.371 0 0 0 9.352 43Z", clipRule: "evenodd" }),
        external_react_default.a.createElement("path", { className: logoIcon_default.a["name-" + theme], fillRule: "evenodd", d: "m67.62 16.71-.08.03.046.075 3.04 4.878h-4.94l-2.703-4.45-.023-.034h-7.107v4.484h-4.181V5.03h13.193c1.9 0 3.5.598 4.622 1.659a5.944 5.944 0 0 1 1.756 4.45c0 2.707-1.384 4.692-3.623 5.57ZM55.925 8.521h-.072v5.207h7.8c.739.049 1.48-.061 2.173-.322.365-.164.67-.435.875-.776.247-.458.367-.973.345-1.492a2.939 2.939 0 0 0-.346-1.515 1.936 1.936 0 0 0-.87-.784 5.172 5.172 0 0 0-2.178-.326h-7.727v.008Zm66.687 9.888h13.432v3.283h-17.7V5.03h17.7v3.298h-13.508v3.557h13.508v2.973h-13.508v3.552h.076Zm19.651-9.24v12.523h-4.181V5.03h5.777l11.509 12.596.13.14V5.045h4.181v16.663h-5.801L142.392 9.12l-.129-.148v.197Zm27.131-.648h-8.127V5.045h20.598v3.477h-8.203v13.171h-4.181V8.522h-.087Zm49.849 8.187-.084.03.046.076 3.041 4.878h-4.942l-2.702-4.45-.019-.034h-7.112v4.484h-4.181V5.03h13.19c1.9 0 3.5.598 4.621 1.659a5.925 5.925 0 0 1 1.772 4.434c0 2.708-1.384 4.693-3.619 5.571l-.011.015Zm-11.711-8.187h-.072v5.207h7.799a5.215 5.215 0 0 0 2.178-.322c.364-.164.667-.435.871-.776.247-.458.367-.973.346-1.492a2.948 2.948 0 0 0-.346-1.515 1.935 1.935 0 0 0-.871-.784 5.164 5.164 0 0 0-2.178-.326h-7.727v.008Zm-19.787 9.888h13.432v3.283h-17.701V5.03h17.701v3.298h-13.505v3.553h13.505v2.976h-13.505v3.553h.073Zm-93.716-5.064c0 2.901-.798 5.045-2.5 6.461-1.704 1.417-4.342 2.129-8.04 2.129-3.698 0-6.328-.701-8.043-2.121-1.714-1.42-2.493-3.556-2.493-6.469V5.045h4.181v8.301c0 1.178.163 2.462 1.05 3.45.885.989 2.473 1.663 5.294 1.663 2.82 0 4.413-.682 5.298-1.674.886-.992 1.05-2.272 1.05-3.439V5.045h4.18v8.301h.023Zm1.578 0c0-2.772.79-4.9 2.493-6.34 1.703-1.438 4.341-2.2 8.046-2.2 3.357 0 5.865.637 7.602 1.864s2.661 3.03 2.874 5.381h-4.288a3.841 3.841 0 0 0-.607-1.669 3.869 3.869 0 0 0-1.293-1.22c-1.03-.618-2.486-.883-4.288-.883-2.212 0-3.801.379-4.838 1.227-1.038.849-1.52 2.11-1.52 3.84 0 1.731.475 3.03 1.52 3.87 1.045.842 2.63 1.243 4.831 1.243 1.801 0 3.246-.273 4.295-.894a3.903 3.903 0 0 0 1.9-2.924h4.273c-.229 2.383-1.171 4.193-2.874 5.416-1.703 1.224-4.23 1.894-7.602 1.894-3.706 0-6.34-.758-8.046-2.22-1.707-1.461-2.478-3.605-2.478-6.385Z", clipRule: "evenodd" })))));
};

// CONCATENATED MODULE: ./src/Icons/Search.tsx

/** Иконка лупа */
function Search(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M7.1.35a6.75 6.75 0 1 0 4.444 11.83l3.563 3.563.636-.636-3.562-3.563A6.75 6.75 0 0 0 7.1.35ZM1.25 7.1a5.85 5.85 0 1 1 11.7 0 5.85 5.85 0 0 1-11.7 0Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/AccountIcon.tsx

/** Иконка аккаунта */
function AccountIcon(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        external_react_default.a.createElement("path", { d: "M10 1.5A4.5 4.5 0 0 0 5.5 6c0 2.485 2.015 5 4.5 5s4.5-2.515 4.5-5A4.5 4.5 0 0 0 10 1.5ZM6.5 6a3.5 3.5 0 1 1 7 0c0 1.933-1.567 4-3.5 4S6.5 7.933 6.5 6ZM17 19v-7H3v7h1v-6h12v6h1Z" })));
}

// CONCATENATED MODULE: ./src/Icons/BurgerIcon.tsx

/** Иконка-бургер */
function BurgerIcon(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        external_react_default.a.createElement("path", { d: "M2 5h16V4H2v1Zm16 5H2V9h16v1Zm0 5H2v-1h16v1Z" })));
}

// CONCATENATED MODULE: ./src/Icons/CartEmptyIcon.tsx

/** Иконка "Пустая корзина" */
function CartEmptyIcon(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1.5A3.5 3.5 0 0 0 6.5 5v1h7V5A3.5 3.5 0 0 0 10 1.5ZM14.5 6V5a4.5 4.5 0 0 0-9 0v1h-.795a2.5 2.5 0 0 0-2.468 2.105l-1.36 8.5A2.5 2.5 0 0 0 3.345 19.5H17.06a2.5 2.5 0 0 0 2.452-2.99l-1.7-8.5A2.5 2.5 0 0 0 15.36 6h-.86ZM4.705 7a1.5 1.5 0 0 0-1.48 1.263l-1.36 8.5a1.5 1.5 0 0 0 1.48 1.737H17.06a1.5 1.5 0 0 0 1.471-1.794l-1.7-8.5A1.5 1.5 0 0 0 15.361 7H4.704Z" })));
}

// CONCATENATED MODULE: ./src/Icons/CartFilledIcon.tsx

/** Иконка "Заполненная корзина" */
function CartFilledIcon(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 .5A4.5 4.5 0 0 0 5.5 5v1h-.958a2 2 0 0 0-1.98 1.726l-1.247 9A2 2 0 0 0 3.296 19h13.408a2 2 0 0 0 1.981-2.274l-1.246-9A2 2 0 0 0 15.46 6H14.5V5A4.5 4.5 0 0 0 10 .5ZM13.5 6V5a3.5 3.5 0 1 0-7 0v1h7Z" })));
}

// CONCATENATED MODULE: ./src/Icons/DotsIcon.tsx

/** Иконка "Три точки" */
function DotsIcon(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        external_react_default.a.createElement("circle", { cx: "16.364", cy: "10", r: "1.818" }),
        external_react_default.a.createElement("circle", { cx: "10", cy: "10", r: "1.818" }),
        external_react_default.a.createElement("circle", { cx: "3.637", cy: "10", r: "1.818" })));
}

// CONCATENATED MODULE: ./src/Icons/Check.tsx

/** Иконка-галочка */
function Check(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 10" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "M13.848 1.359 5.268 9.697.152 4.727l.696-.717 4.419 4.293L13.152.64l.697.718Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/Close.tsx

/** Иконка-крестик */
function Close(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", d: "m10 9.281 5.303-5.303.707.707-5.303 5.303 5.303 5.303-.707.708L10 10.695 4.697 16l-.707-.708 5.303-5.303L3.99 4.685l.707-.707L10 9.28Z", clipRule: "evenodd" })));
}

// CONCATENATED MODULE: ./src/Icons/LangIcon.tsx

/** Иконка языка */
function LangIcon(_a) {
    var className = _a.className;
    return (external_react_default.a.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "none" },
        external_react_default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1ZM1.96107 9.52632C2.18358 5.69043 5.09107 2.57498 8.83206 2.03145C6.99005 4.17492 5.8621 6.74468 5.74666 9.52632H1.96107ZM1.96107 10.4737C2.18357 14.3095 5.09096 17.4249 8.83186 17.9685C6.98993 15.8251 5.86204 13.2553 5.74665 10.4737H1.96107ZM6.69493 10.4737C6.81922 13.2146 8.01844 15.7567 9.99996 17.8493C11.9815 15.7567 13.1807 13.2146 13.305 10.4737H6.69493ZM14.2533 10.4737C14.1379 13.2553 13.01 15.8251 11.1681 17.9685C14.909 17.425 17.8164 14.3095 18.0389 10.4737H14.2533ZM18.0389 9.52632H14.2533C14.1378 6.74467 13.0099 4.17491 11.1679 2.03144C14.9089 2.57494 17.8164 5.69041 18.0389 9.52632ZM13.305 9.52632H6.69494C6.81928 6.78552 8.01848 4.24342 9.99996 2.15087C11.9814 4.24342 13.1807 6.78552 13.305 9.52632Z" })));
}

// CONCATENATED MODULE: ./src/Icons/index.tsx




















// CONCATENATED MODULE: ./index.ts



/***/ })
/******/ ]);